import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./PatientAssessment.css";
import axios from "axios";

const PatientAssessment = (props) => {
  const { id } = useParams();
  let navigate = useNavigate();
  const [saveUnclickable, setSaveUnclickable] = useState(false);
  const [contentLoaded, setContentLoaded] = useState(false);

  useEffect(() => {
    props.actSidebar(false);
    if (id) {
      var userData = JSON.parse(localStorage.getItem("userData"));
      if (userData === null) {
        props.checkLoggedIn(false);
      } else {
        axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
        axios
          .post(window.ajaxLink + "cloud_therapist/get-assessment-questions", { id })
          .then((res) => {
            if (res.data.responseData) {
              setAssessmentState(res.data.responseData);
              setContentLoaded(true);
            }
          })
          .catch((error) => {
            console.error(error);
            if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
              props.checkLoggedIn(false);
            }
            if (error.response.data.errorData.message === "Assessment does not exist!") {
              setSaveUnclickable(true);
            }
          });
      }
    }
  }, [props, id]);

  useEffect(() => {
    axios
      .post(window.ajaxLink + "cloud_therapist/get-assessment-edits", { id })
      .then((res) => {
        if (res.data.responseData) {
          setAssessmentAnswers(res.data.responseData);
        }
      })
      .catch((error) => {
        console.error(error);
      });
      // eslint-disable-next-line
  }, []);

  const [assessmentState, setAssessmentState] = useState({});
  const [assessmentAnswers, setAssessmentAnswers] = useState({});
  const alterAnswer = (question, value, table_ans) => {
    var arrAnswer = { ...assessmentAnswers };
    if (!table_ans) {
      arrAnswer[question] = value;
    } else if (value === true) {
      arrAnswer[question] = { [table_ans]: value };
    } else {
      if (!arrAnswer[question]) {
        arrAnswer[question] = {};
      }
      arrAnswer[question][table_ans] = value;
    }
    setAssessmentAnswers(arrAnswer);
  };

  const saveAssessment = () => {
    var answerCheck = [];
    for (var sections of assessmentState.sections) {
      for (var questions of sections.questions) {
        if (
          questions.question_id !== 6 &&
          questions.question_id !== 33 &&
          questions.question_id !== 34 &&
          questions.question_id !== 46 &&
          questions.question_id !== 47 &&
          questions.question_type !== "select" &&
          questions.question_type !== "table_row_name"
        ) {
          answerCheck.push(questions.question_id);
        }
      }
    }

    for (var answer of answerCheck) {
      if (assessmentAnswers[answer] === "" || assessmentAnswers[answer] === undefined) {
        setErrorPopUp("Please fill in all the fields.");
        return false;
      } else {
        setErrorPopUp("");
      }
    }

    setContentLoaded(false);
    //setErrorInputs(false);

    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "cloud_therapist/save-assessment-answers", {
        patient_id: id ? id : 0,
        assessment_answers: assessmentAnswers,
      })
      .then((res) => {
        if (res.data.responseData) {
          setSuccessPopUp("Initial Evaluation");
          setContentLoaded(true);
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.response.data.errorData.message) {
          setErrorPopUp(error.response.data.errorData.message);
        }
        //setErrorInputs(true);
        return false;
      });
  };
  const [successPopUp, setSuccessPopUp] = useState("");
  const [errorPopUp, setErrorPopUp] = useState("");
  const popupRef = useRef(errorPopUp);
  useEffect(() => {
    popupRef.current = errorPopUp;
    const timeout = setTimeout(() => {
      setErrorPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [errorPopUp]);

  const [numOfIterations] = useState([{}, {}, {}, {}]);

  //const [errorInputs, setErrorInputs] = useState(false);
  //console.log(JSON.stringify(assessmentState));

  return (
    <div>
      <div className="prog_det_top_hold vt_top pa_top">
        <>
          {/* <div className="prog_back_icon"></div>
          <Link to={"/myPatients"}>
            <div className="prog_det_back_text">Back to Patients</div>
          </Link> */}
        </>
        <div className="prog_det_title vt_title_reduce examination_title_reduce">Examination</div>
        <div className="cancel_and_save_examination">
          {/* <Link to={"/myPatients"}> */}
          <div className="prog_edit_btn prog_save_btn examination_save examination_cancel" onClick={() => navigate(-1)}>
            Cancel
          </div>
          {/* </Link> */}
          <div
            className="prog_edit_btn prog_save_btn examination_save"
            onClick={() => (saveUnclickable ? "" : saveAssessment())}
          >
            Save Examination
          </div>
        </div>
      </div>

      <div className="vt_overall pa_page_padd">
        {contentLoaded &&
          numOfIterations.map((iter, i) => (
            <div className="virtual_hold pa_tab">
              {assessmentState &&
                assessmentState.sections &&
                assessmentState.sections.map((section, s) =>
                  (i === 0 && (s === 0 || s === 1)) ||
                  (i === 1 && (s === 2 || s === 3 || s === 4)) ||
                  (i === 2 && (s === 5 || s === 6 || s === 7)) ||
                  (i === 3 && (s === 8 || s === 9 || s === 10)) ? (
                    <div key={s} className={"" + (section.section_type === "table" ? "virtual_hold pa_table" : "")}>
                      {section.section_type !== "table" ? (
                        <>
                          {section.section_name !== "" ? (
                            <div
                              className={
                                "vth_title pa_title " +
                                (section.answers &&
                                section.answers[0] &&
                                section.answers[0].question_type === "question_card"
                                  ? " pa_title_cards_below"
                                  : "")
                              }
                            >
                              {section.section_name}
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      ) : section.section_type === "table" ? (
                        <>
                          <div className="pa_table_row">
                            <div className="pa_cell pa_desc_cell pa_desc_emphasis">{section.section_name}</div>
                            <div className="pa_cell pa_cell_short">Maj</div>
                            <div className="pa_cell pa_cell_short">Mod</div>
                            <div className="pa_cell pa_cell_short">Min</div>
                            <div className="pa_cell pa_cell_short">Nul</div>
                            <div className="pa_cell pa_cell_fill">Symptoms</div>
                          </div>
                        </>
                      ) : section.section_type === "table_long" ? (
                        <div className="virtual_hold pa_table pa_long_t">
                          {/* <div className="vth_title pa_title pa_title_cards_below">{section.section_name}</div> */}
                        </div>
                      ) : (
                        ""
                      )}
                      <div className={section.section_type === "table_long" ? "virtual_hold pa_table pa_long_t" : ""}>
                        {section.description && <div className="pa_card_desc">{section.description}</div>}
                        {section.section_type === "table_long" && (
                          <>
                            <div className="pa_table_row pa_table_row_lng_desc">
                              <div className="pa_cell pa_cell_first_empty_one"></div>
                              <div className="pa_cell pa_cell_border_left">Symptomatic response</div>
                              <div className="pa_cell pa_cell_border_right">Mechanical response</div>
                            </div>
                            <div className="pa_table_row pa_table_row_lng_desc">
                              <div className="pa_cell pa_desc_cell pa_desc_cell_extended"></div>
                              <div className="pa_cell pa_desc_cell pa_desc_cell_extended">During testing</div>
                              <div className="pa_cell pa_desc_cell pa_desc_cell_extended">After testing</div>
                              <div className="pa_cell pa_desc_cell pa_desc_cell_extended">ROM or key functional</div>
                              <div className="pa_cell pa_desc_cell pa_cell_last">No effect</div>
                            </div>
                          </>
                        )}
                        {section.questions &&
                          section.questions.map((question, q) => (
                            <div
                              className={
                                (section.section_type !== "table" &&
                                section.section_type !== "table_long" &&
                                question.question_type !== "input_long" &&
                                question.question_name !== " "
                                  ? "pa_side"
                                  : "") +
                                (question.question_type === "question_card" && q > 1 ? " pa_side_third" : "") +
                                (question.question_name === " " ? " pa_cards_one_row" : "")
                              }
                            >
                              {question.question_type === "question_card" ? (
                                <>
                                  {question.question_name !== " " && (
                                    <div key={q} className="formSubtitle paSubtitle">
                                      {question.question_name}
                                    </div>
                                  )}
                                  {question.answers &&
                                    question.answers.map((answer, a) => (
                                      <>
                                        <div
                                          key={a}
                                          className={
                                            "question_single_card pa_sg_card " +
                                            (assessmentAnswers[question.question_id] === answer.name ||
                                            (assessmentAnswers[question.question_id] &&
                                              assessmentAnswers[question.question_id].card_val) === answer.name
                                              ? " question_card_active"
                                              : "")
                                          }
                                          onClick={() =>
                                            alterAnswer(
                                              question.question_id,
                                              answer.name,
                                              question.optional_answer ? "card_val" : undefined
                                            )
                                          }
                                        >
                                          {answer.name}
                                        </div>
                                      </>
                                    ))}
                                  {question.optional_answer === true && (
                                    <div className="pa_input_hold">
                                      <input
                                        maxlength="100"
                                        value={
                                          assessmentAnswers[question.question_id] &&
                                          assessmentAnswers[question.question_id].optional
                                            ? assessmentAnswers[question.question_id].optional
                                            : ""
                                        }
                                        onChange={(e) => alterAnswer(question.question_id, e.target.value, "optional")}
                                      />
                                    </div>
                                  )}
                                </>
                              ) : question.question_type === "input" ? (
                                <div
                                  className={
                                    "pa_input_hold" +
                                    (question.question_name !== " " && question.question_name !== "Other observations"
                                      ? ""
                                      : " pa_input_lng_hold")
                                  }
                                >
                                  <div key={q} className="pa_inp_desc">
                                    {question.question_name}
                                  </div>
                                  <input
                                    maxlength="100"
                                    style={
                                      question.question_name === "Other observations"
                                        ? { display: "block" }
                                        : { display: "inline-block" }
                                    }
                                    placeholder={
                                      question.question_name === "Other observations" || question.question_name === " "
                                        ? "Notes (Optional)"
                                        : ""
                                    }
                                    value={assessmentAnswers[question.question_id]}
                                    onChange={(e) => alterAnswer(question.question_id, e.target.value)}
                                  />
                                </div>
                              ) : question.question_type === "input_long" ? (
                                <div className={question.question_name !== " " ? "pa_side" : ""}>
                                  <div
                                    className={
                                      "pa_input_hold" + (question.question_name !== " " ? "" : " pa_input_lng_hold")
                                    }
                                  >
                                    {question.question_name !== " " && (
                                      <div key={q} className="pa_inp_desc">
                                        {question.question_name}
                                      </div>
                                    )}
                                    <input
                                      maxlength="100"
                                      value={assessmentAnswers[question.question_id]}
                                      onChange={(e) => alterAnswer(question.question_id, e.target.value)}
                                    />
                                  </div>
                                </div>
                              ) : section.section_type === "table" ? (
                                <div className={"pa_table_row" + (q === question.length - 1 ? " pa_last_row" : "")}>
                                  <div className="pa_cell pa_desc_cell">{question.question_name}</div>
                                  <div className="pa_cell pa_cell_short">
                                    <div
                                      className={
                                        "pa_table_rad questionareField_radio_box" +
                                        (assessmentAnswers[question.question_id] &&
                                        assessmentAnswers[question.question_id].Maj
                                          ? " radio_checked"
                                          : "")
                                      }
                                      onClick={() => alterAnswer(question.question_id, true, "Maj")}
                                    >
                                      <div
                                        className={
                                          "questionareField_radio_box_inner " +
                                          (assessmentAnswers[question.question_id] &&
                                          assessmentAnswers[question.question_id].Maj
                                            ? "container_checked"
                                            : "")
                                        }
                                      ></div>
                                    </div>
                                  </div>
                                  <div className="pa_cell pa_cell_short">
                                    <div
                                      className={
                                        "pa_table_rad questionareField_radio_box" +
                                        (assessmentAnswers[question.question_id] &&
                                        assessmentAnswers[question.question_id].Mod
                                          ? " radio_checked"
                                          : "")
                                      }
                                      onClick={() => alterAnswer(question.question_id, true, "Mod")}
                                    >
                                      <div
                                        className={
                                          "questionareField_radio_box_inner " +
                                          (assessmentAnswers[question.question_id] &&
                                          assessmentAnswers[question.question_id].Mod
                                            ? "container_checked"
                                            : "")
                                        }
                                      ></div>
                                    </div>
                                  </div>
                                  <div className="pa_cell pa_cell_short">
                                    <div
                                      className={
                                        "pa_table_rad questionareField_radio_box" +
                                        (assessmentAnswers[question.question_id] &&
                                        assessmentAnswers[question.question_id].Min
                                          ? " radio_checked"
                                          : "")
                                      }
                                      onClick={() => alterAnswer(question.question_id, true, "Min")}
                                    >
                                      <div
                                        className={
                                          "questionareField_radio_box_inner " +
                                          (assessmentAnswers[question.question_id] &&
                                          assessmentAnswers[question.question_id].Min
                                            ? "container_checked"
                                            : "")
                                        }
                                      ></div>
                                    </div>
                                  </div>
                                  <div className="pa_cell pa_cell_short">
                                    <div
                                      className={
                                        "pa_table_rad questionareField_radio_box" +
                                        (assessmentAnswers[question.question_id] &&
                                        assessmentAnswers[question.question_id].Nil
                                          ? " radio_checked"
                                          : "")
                                      }
                                      onClick={() => alterAnswer(question.question_id, true, "Nil")}
                                    >
                                      <div
                                        className={
                                          "questionareField_radio_box_inner " +
                                          (assessmentAnswers[question.question_id] &&
                                          assessmentAnswers[question.question_id].Nil
                                            ? "container_checked"
                                            : "")
                                        }
                                      ></div>
                                    </div>
                                  </div>
                                  <div className="pa_cell pa_cell_fill">
                                    <div className="pa_input_table">
                                      <input
                                        maxlength="100"
                                        value={
                                          assessmentAnswers[question.question_id] &&
                                          assessmentAnswers[question.question_id].symptoms
                                            ? assessmentAnswers[question.question_id].symptoms
                                            : ""
                                        }
                                        onChange={(e) => alterAnswer(question.question_id, e.target.value, "symptoms")}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ) : section.section_type === "table_long" ? (
                                <>
                                  {question.question_type === "table_row" ? (
                                    <div className="pa_table_row_lng">
                                      <div className="pa_cell pa_desc_cell pa_cell_shortened">
                                        {question.question_name}
                                      </div>
                                      <div className="pa_cell pa_desc_cell pa_cell_shortened">
                                        <div className="pa_input_table">
                                          <input
                                            maxlength="100"
                                            value={
                                              assessmentAnswers[question.question_id] &&
                                              assessmentAnswers[question.question_id].during_testing
                                                ? assessmentAnswers[question.question_id].during_testing
                                                : ""
                                            }
                                            onChange={(e) =>
                                              alterAnswer(question.question_id, e.target.value, "during_testing")
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="pa_cell pa_desc_cell pa_cell_shortened">
                                        <div className="pa_input_table">
                                          <input
                                            maxlength="100"
                                            value={
                                              assessmentAnswers[question.question_id] &&
                                              assessmentAnswers[question.question_id].after_testing
                                                ? assessmentAnswers[question.question_id].after_testing
                                                : ""
                                            }
                                            onChange={(e) =>
                                              alterAnswer(question.question_id, e.target.value, "after_testing")
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="pa_cell pa_desc_cell pa_cell_shortened">
                                        <div className="pa_input_table">
                                          <input
                                            maxlength="100"
                                            value={
                                              assessmentAnswers[question.question_id] &&
                                              assessmentAnswers[question.question_id].effect
                                                ? assessmentAnswers[question.question_id].effect
                                                : ""
                                            }
                                            onChange={(e) =>
                                              alterAnswer(question.question_id, e.target.value, "effect")
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="pa_cell pa_desc_cell pa_cell_shortened pa_cell_last">
                                        <div
                                          className={
                                            "pa_table_rad questionareField_radio_box" +
                                            (assessmentAnswers[question.question_id] &&
                                            assessmentAnswers[question.question_id].no_effect === "true"
                                              ? " radio_checked"
                                              : "")
                                          }
                                          onClick={() =>
                                            alterAnswer(
                                              question.question_id,
                                              !assessmentAnswers[question.question_id] ||
                                                assessmentAnswers[question.question_id].no_effect !== "true"
                                                ? "true"
                                                : "false",
                                              "no_effect"
                                            )
                                          }
                                        >
                                          <div
                                            className={
                                              "questionareField_radio_box_inner " +
                                              (assessmentAnswers[question.question_id] &&
                                              assessmentAnswers[question.question_id].no_effect === "true"
                                                ? "container_checked"
                                                : "")
                                            }
                                          ></div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : question.question_type === "table_row_name" ? (
                                    <div className="pa_table_row pa_descriptive_row">{question.question_name}</div>
                                  ) : (
                                    ""
                                  )}
                                </>
                              ) : question.question_type === "text_area" ? (
                                <div>
                                  <div className="pa_inp_desc">{question.question_name}</div>
                                  <textarea
                                    maxLength={250}
                                    placeholder={
                                      question.question_name === "Descriptions" ? "Enter text" : "Notes (Optional)"
                                    }
                                    className={
                                      question.question_name === "Descriptions" ? "pa_text_area" : "pa_text_area_other"
                                    }
                                    value={assessmentAnswers[question.question_id]}
                                    onChange={(e) => alterAnswer(question.question_id, e.target.value)}
                                  ></textarea>
                                </div>
                              ) : question.question_type === "select" ? (
                                <div className="pa_input_hold">
                                  <div className="pa_inp_desc">{question.question_name}</div>
                                  <select>
                                    <option>Select</option>
                                  </select>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          ))}
                      </div>
                    </div>
                  ) : (
                    ""
                  )
                )}
            </div>
          ))}
      </div>
      {successPopUp && (
        <div className="dlt_wrapper" style={{ position: "fixed" }}>
          <div className="dbl_place_on_page">
            <div className="dlt_surround">
              <div className="dlt_title">Save Confirmation</div>
              <div className="dlt_description">Your {successPopUp} has been successfully saved.</div>
              <div className="dlt_exit_btm">
                <div className="dlt_exit_btn dlt_eb_scnd dlt_lone_btn" onClick={() => navigate("/myPatients")}>
                  OK
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {errorPopUp && (
        <div className="prog_err_hold">
          <div className="prog_err_icon"></div>
          <div className="prog_err_text">{errorPopUp}</div>
        </div>
      )}
      {!contentLoaded && (
        <div className="loader_full_container">
          <div className="p_load"></div>
        </div>
      )}
      {/* {aboutToDelete && (
        <div className="dbl_place_on_page">
          <div className="dlt_surround dlt_box">
            <div className="dlt_title">Delete Confirmation</div>
            <div className="dlt_description">
              <p>Do you want to delete this {aboutToDelete}?</p>
            </div>
            <div className="dlt_exit_btm">
              <div className="dlt_exit_btn dlt_eb_first" onClick={() => handleDeletion()}>
                Cancel
              </div>
              <div className="dlt_exit_btn dlt_eb_scnd" onClick={() => handleDeletion(true)}>
                Delete
              </div>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default PatientAssessment;
